<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <!-- {{ license_cd_obj }} -->
    <div class="position-relative" style="z-index: 10">
      <div class="w100 mb-5">
        <div class="row mb-3">
          <div class="col-6 mb-2">
            <label for="LicenseNo" class="form-label">ライセンスNo</label>
            <input
              type="text"
              class="form-control"
              id="LicenseNo"
              placeholder="ライセンスNo"
              :disabled="!form_editable"
              v-model="(migration_obj || {}).license_no"
            />
          </div>
          <div class="col-6 mb-2">
            <label for="BirthDate" class="form-label">生年月日</label>
            <input
              type="date"
              class="form-control"
              id="BirthDate"
              placeholder="生年月日"
              :disabled="!form_editable"
              v-model="(migration_obj || {}).birth_date"
            />
          </div>
          <div class="col-3 mb-2">
            <label for="UpperLicenseCd" class="form-label">状況</label>
            <bs-select
              :options="step_list"
              v-model="(migration_obj || {}).step"
              :null-option="false"
              :disabled="!form_editable"
              :PrefCd="'form-select'"
            ></bs-select>
          </div>
          <div class="col-6">
            <label for="Token" class="form-label">TOKEN</label>
            <input
              type="text"
              class="form-control"
              id="Token"
              placeholder="TOKEN"
              :disabled="!form_editable"
              v-model="(migration_obj || {}).token"
            />
          </div>
          <div class="col-3">
            <label for="PassCd" class="form-label">確認番号</label>
            <input
              type="text"
              class="form-control"
              id="PassCd"
              :disabled="!form_editable"
              placeholder="確認番号"
              v-model="(migration_obj || {}).pass_cd"
            />
          </div>
        </div>
      </div>
      <!-- {{race_series_obj.license_exclude}} -->
    </div>
    <div class="position-relative" style="z-index: 10">
      <div class="w100 mb-5">
        <div class="row mb-3">
          <div class="col-5 mb-2">
            <h4>申請情報</h4>
            <table class="table">
              <tbody>
                <tr v-for="item in migration_obj?.items" :key="item">
                  <th style="width: 30%">
                    {{ get_list_label(item.migration_key, migration_key_list) }}
                  </th>
                  <td v-if="item.migration_key.startsWith('photo_type_')">
                    <span v-if="migration_obj?.del_file_flg >= 1">移行済</span>
                    <img :src="item?.migration_value" class="w-100" v-else />
                  </td>
                  <td v-else-if="item.migration_key == 'identify_type'">
                    {{
                      get_list_label(
                        item?.migration_value,
                        identify_type_cd_obj
                      )
                    }}
                  </td>
                  <td v-else-if="item.migration_key == 'login_pass'">******</td>
                  <td v-else-if="form_editable">
                    <input
                      type="text"
                      v-model="(item || {}).migration_value"
                      class="form-control"
                    />
                  </td>
                  <td v-else>
                    {{ item?.migration_value }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-7 mb-2">
            <h4>登録情報</h4>
            <table class="table">
              <tbody>
                <tr>
                  <th>ライセンス年度</th>
                  <td>{{ migration_obj?.member?.license_year }}</td>
                  <th>ライセンスNo</th>
                  <td>{{ migration_obj?.member?.license_no }}</td>
                </tr>
                <tr>
                  <th>氏名</th>
                  <td>
                    {{ migration_obj?.member?.name_1
                    }}{{ migration_obj?.member?.name_2 }}
                  </td>
                  <th>ヨミ</th>
                  <td>
                    {{ migration_obj?.member?.yomi_1
                    }}{{ migration_obj?.member?.yomi_2 }}
                  </td>
                </tr>
                <tr>
                  <th>生年月日</th>
                  <td>{{ migration_obj?.member?.birth_date }}</td>
                  <th>性別</th>
                  <td>
                    {{
                      migration_obj?.member?.sex_type == 'male'
                        ? '男性'
                        : migration_obj?.member?.sex_type == 'female'
                        ? '女性'
                        : '不明'
                    }}
                  </td>
                </tr>
                <tr>
                  <th>申請区分</th>
                  <td>
                    {{ migration_obj?.member?.add_type == 1 ? '新規' : '継続' }}
                  </td>
                  <th>郵便番号</th>
                  <td>{{ migration_obj?.member?.postal_cd }}</td>
                </tr>
                <tr>
                  <th>都道府県</th>
                  <td>
                    {{
                      get_list_label(migration_obj?.member?.pref_cd, pref_obj)
                    }}
                  </td>
                  <th>住所</th>
                  <td>
                    {{ migration_obj?.member?.address_1 }}<br />{{
                      migration_obj?.member?.address_2
                    }}
                  </td>
                </tr>
                <tr>
                  <th>電話番号</th>
                  <td>
                    {{ migration_obj?.member?.tel_1 }}<br />{{
                      migration_obj?.member?.tel_2
                    }}
                  </td>
                  <th>メールアドレス</th>
                  <td>
                    {{ migration_obj?.member?.mail_1 }}<br />{{
                      migration_obj?.member?.mail_2
                    }}
                  </td>
                </tr>
                <tr>
                  <th>入会日</th>
                  <td>{{ migration_obj?.member?.application_date }}</td>
                  <th>クラブ</th>
                  <td>
                    {{ migration_obj?.member?.club_cd
                    }}{{ migration_obj?.member?.club_name }}
                  </td>
                </tr>
              </tbody>
            </table>
            <h4>ライセンス</h4>
            <table class="table">
              <thead>
                <tr>
                  <th v-if="form_editable">削除</th>
                  <th>年度</th>
                  <th>ライセンスID</th>
                  <th>開始</th>
                  <th>終了</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="license in migration_obj.license" :key="license">
                  <td v-if="form_editable">
                    <input type="checkbox" v-model="license.del_flg" />
                  </td>
                  <td>
                    {{ license.license_year }}
                  </td>
                  <td>
                    {{ get_license_label(license.license_cd) }}({{
                      license.license_cd
                    }})
                  </td>
                  <td>
                    <input
                      type="date"
                      class="form-control form-control-sm"
                      placeholder="開始"
                      :disabled="!form_editable"
                      v-model="license.license_term_start_date"
                    />
                  </td>
                  <td>
                    <input
                      type="date"
                      class="form-control form-control-sm"
                      placeholder="期限"
                      :disabled="!form_editable"
                      v-model="license.license_term_end_date"
                    />
                  </td>
                </tr>
              </tbody>
              <tbody v-if="form_editable">
                <tr v-for="form in add_license_form" :key="form">
                  <td colspan="2">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      placeholder="年度"
                      :disabled="!form_editable"
                      v-model="form.license_year"
                    />
                  </td>
                  <td>
                    <bs-select
                      :options="license_cd_list"
                      v-model="form.license_cd"
                      :null-option="false"
                      :disabled="!form_editable"
                      :PrefCd="'form-select'"
                    ></bs-select>
                  </td>
                  <td>
                    <input
                      type="date"
                      class="form-control form-control-sm"
                      placeholder="開始"
                      :disabled="!form_editable"
                      v-model="form.license_term_start_date"
                    />
                  </td>
                  <td>
                    <input
                      type="date"
                      class="form-control form-control-sm"
                      placeholder="期限"
                      :disabled="!form_editable"
                      v-model="form.license_term_end_date"
                    />
                  </td>
                </tr>
              </tbody>
              <tfoot v-if="form_editable">
                <tr>
                  <th colspan="5">
                    <div class="text-end">
                      <button
                        @click="add_license"
                        class="btn btn-light btn-outline-secondary"
                      >
                        追加
                      </button>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div
      class="position-sticky bottom-0 bg-light pt-3 pb-2 px-2 border rounded-1"
      style="z-index: 110"
    >
      <div class="row mb-3">
        <div class="col-12 col-sm-4 mb-2">
          <button
            v-if="form_editable"
            type="submit"
            @click="chg_mode('view')"
            class="btn btn-light btn-outline-secondary"
          >
            照会に戻る
          </button>
          <button
            v-else
            type="submit"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div
          class="col-12 col-sm-4 mb-2 text-center"
          v-if="
            migration_obj.step == 7 &&
            chk_relation_type_editable('/master/list')
          "
        >
          <button type="submit" @click="go_app" class="btn btn-success">
            承認する
          </button>
        </div>
        <div
          class="col-12 col-sm-4 mb-2 text-center"
          v-if="
            migration_obj.step == 10 &&
            chk_relation_type_editable('/master/list')
          "
        >
          <button type="submit" class="btn btn-dark">以降済</button>
        </div>
        <div
          class="col-12 col-sm-4 mb-2 text-center"
          v-else-if="chk_relation_type_editable('/master/list')"
        >
          <button disabled class="btn btn-dark">
            申請前なので承認できません
          </button>
        </div>
        <div
          class="col-12 col-sm-4 mb-2 text-end"
          v-if="chk_relation_type_editable('/master/list')"
        >
          <button
            type="submit"
            @click="chg_mode('edit')"
            class="btn btn-warning"
            v-if="mode == 'view'"
          >
            編集する
          </button>
          <button
            type="submit"
            @click="go_update"
            class="btn btn-primary"
            v-else-if="mode == 'edit'"
          >
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
// import '../../assets/bootstrap/css/sc.css';
import config from '../../../const'

export default {
  name: 'LicenseCdDetailView',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: '移行データ',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      migration_obj: {},
      mode: 'view',
      pref_obj: [],
      identify_type_cd_obj: [],
      license_cd_obj: [],
      add_license_form: [],
      step_list: [
        {
          key: 0,
          label: '移行前'
        },
        {
          key: 1,
          label: 'メール送信'
        },
        {
          key: 5,
          label: 'メール確認済'
        },
        {
          key: 7,
          label: '申請内容チェック'
        },
        {
          key: 10,
          label: '移行済'
        }
      ],
      migration_key_list: [
        {
          key: 'mail_address',
          label: 'メールアドレス'
        },
        {
          key: 'up_mail_address',
          label: '更新アドレス'
        },
        {
          key: 'login_id',
          label: 'ログインID'
        },
        {
          key: 'login_pass',
          label: 'ログインパス'
        },
        {
          key: 'identify_type',
          label: '本人確認書類種類'
        },
        {
          key: 'photo_type_1',
          label: '顔写真'
        },
        {
          key: 'photo_type_2',
          label: '本人確認書類1'
        },
        {
          key: 'photo_type_3',
          label: '本人確認書類2'
        }
      ]
    }
  },
  components: {
    BsPageTitle,
    BsSelect,
    BsMsgAlert
    // BsButton,
    // BsCheckBox,
  },
  methods: {
    add_license() {
      const add_form = {
        id: 0,
        stat: 1,
        migration_id: this.targetid,
        license_no: (this.migration_obj || {}).license_no,
        license_cd: 0,
        license_event_cd: 0,
        license_year: '',
        license_add_type: '',
        license_term_start_date: '',
        license_term_end_date: ''
      }
      const adds = [...this.add_license_form]
      adds.push({ ...add_form })
      this.add_license_form = adds
    },
    back() {
      this.$router.go(-1)
    },
    chg_mode(mode) {
      this.mode = mode
    },
    async go_app() {
      const params = { ...this.migration_obj }

      params.step = 10
      params.finish = 1
      // console.log('go_app params', params)
      await this.update(params)
    },
    async go_update() {
      const params = this.migration_obj
      if (
        Array.isArray(this.add_license_form) &&
        this.add_license_form.length > 0
      ) {
        const tmps = [...params.license]
        this.add_license_form.map(license_form => {
          tmps.push(license_form)
        })
        this.add_license_form = []
        params.license = tmps
      }
      // console.log('go_app params', params)
      await this.update(params)
    },
    async update(params) {
      const url = this.not_add
        ? config.BASE_API_URL + '/member_migration/edit/' + this.targetid
        : config.BASE_API_URL + '/member_migration/add'

      await this.basicPosts_I(url, params)
        .then(async response => {
          console.log('update response', response)
          if (response?.data?.status === 200) {
            alert('更新しました')
            this.mode = 'view'
            await this.loadMigrationObj()
          } else {
            alert('error')
          }
        })
        .catch(async err => {
          console.log(err)
          this.migration_obj = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadMigrationObj() {
      const params = {}
      params['id'] = this.not_add ? this.targetid : 0
      await this.basicPosts_S(
        config.BASE_API_URL + '/member_migration/lists',
        params
      )
        .then(async response => {
          console.log('loadMigrationList response', response)
          const mobj = response?.data?.body ? response.data.body[0] : {}
          if (Array.isArray(mobj?.license)) {
            mobj.license = mobj.license.map(license => {
              license.del_flg = 0
              return license
            })
          }

          this.migration_obj = mobj
        })
        .catch(async err => {
          console.log(err)
          this.migration_obj = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/license_cd/lists', params)
        .then(async response => {
          console.log('loadLicenseCdList response', response)
          this.license_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    }
  },
  computed: {
    get_license_label: function () {
      const get_func = this.get_license_data
      return function (license_id) {
        if (get_func(license_id)) {
          return get_func(license_id)?.label
        }
        return ''
      }
    },
    get_license_data: function () {
      const license_cd_obj = this.license_cd_obj
      return function (license_cd) {
        return license_cd_obj.find(license => license.id == license_cd)
      }
    },
    license_cd_list: function () {
      return this.license_cd_obj
    },
    ...mapState({}),
    get_list_label: function () {
      return function (key, lists) {
        // if (key === '0') return '未選択'
        if (
          typeof lists === 'object' &&
          typeof lists.find(list => list.key == key) === 'object'
        ) {
          return lists.find(list => list.key == key).label
        }
        return key
      }
    },
    not_add: function () {
      return this.targetid != 'add' && !Number.isNaN(this.targetid)
        ? true
        : false
    },
    form_editable: function () {
      return this.mode == 'edit' ? true : false
    }
  },

  async created() {
    await this.loadLicenseCdList()
    this.pref_obj = await this.getConfigAPI('pref')
    this.identify_type_cd_obj = await this.getConfigAPI('identify_type_cd')
    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      this.loadMigrationObj()
      this.btnLabel = '更新'
    } else {
      this.migration_obj = {
        id: 0,
        license_no: '',
        m_id: 0,
        birth_date: '',
        items: []
      }
      this.btnLabel = '登録'
      // await this.loadRaceSeriesList()
    }
    this.alertMessage = this.btnLabel + 'できます'
  },
  mounted: function () {
    this.fromParentTitle = 'シリーズデータ詳細'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
